import { render, staticRenderFns } from "./ItemContainer.vue?vue&type=template&id=450d5606&scoped=true"
import script from "./ItemContainer.vue?vue&type=script&lang=js"
export * from "./ItemContainer.vue?vue&type=script&lang=js"
import style0 from "./ItemContainer.vue?vue&type=style&index=0&id=450d5606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d5606",
  null
  
)

export default component.exports